import {
  Component,
  OnInit,
  ElementRef,
  Renderer2,
  AfterViewInit,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { MatTableDataSource } from '@angular/material/table';
import { Actions, ofType } from '@ngrx/effects';

import { encodeWorkItemStudentsGradeSuccess } from 'src/app/store/actions/professor.action';
import { encodeWorkItemStudentsGrade } from 'src/app/store/actions/professor.action';
import { getWorkItemStudentsGrade } from 'src/app/store/actions/professor.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';

import { selectWorkItemStudentsGrade } from 'src/app/store/selectors/professor.selector';

export interface GradeItem {
  category_name: string;
  component_name: string;
  firstname: string;
  grade_code: string;
  grade_value: number;
  lastname: string;
  student_grade: number;
  student_id: number;
  maxPoints: number;
}

@Component({
  selector: 'app-add-grade',
  templateUrl: './add-grade.component.html',
  styleUrls: ['./add-grade.component.scss'],
})
export class AddGradeComponent implements OnInit, AfterViewInit {
  data!: any;

  getGrades$: Observable<any>;
  // Mat-table data
  displayedColumns: string[] = ['number', 'student', 'current', 'points', 'remarks'];
  dataSource: MatTableDataSource<GradeItem>;

  workItemData: any = {
    subject_name: '',
    subject_code: '',
    component: '',
    category: '',
    code: ''
  }

  public onClose: Subject<any> = new Subject();

  ngUnsubscribe = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    public bsModalRef: BsModalRef,
    private renderer: Renderer2,
    private actions$: Actions,
    private fb: FormBuilder,
    private el: ElementRef,
  ) {
    this.getGrades$ = this.store.select(selectWorkItemStudentsGrade);

    this.actions$.pipe(ofType(encodeWorkItemStudentsGradeSuccess)).subscribe(() => {
      this.dataSource.data = [];
      this.cdr.detectChanges();

      this.onClose.next({ action: 'save', data: [] });
      this.bsModalRef.hide();
    });
  }

  ngOnInit(): void {
    this.workItemData = {
      subject_name: this.data.subject_name,
      subject_code: this.data.subject_code,
      component: this.data.component_name,
      category: this.data.category_name,
      code: this.data.work_item_code
    }

    this.getGrades$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res) {
        this.dataSource = new MatTableDataSource(res?.data);
        this.cdr.detectChanges(); 
      }
    })

    this.initStudentsData();
  }

  ngAfterViewInit(): void {}

  initStudentsData(): void {
    this.dataSource.data = [];
    this.cdr.detectChanges();

    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(getWorkItemStudentsGrade({
      subjectId: this.data.subject_id,
      componentId: this.data.component_id,
      categoryId: this.data.category_id,
      workItemId: this.data.work_item_id
    }));
  }

  updatePoints(index: number, event: any): void {
    const value = parseInt(event.target.value);
    if (
      !isNaN(value) &&
      value >= 0 &&
      value <= this.dataSource.data[index].grade_value
    ) {
      this.dataSource.data[index].student_grade = value;
    } else {
      event.target.value = this.dataSource.data[index].student_grade;
    }
  }

  save(): void {
    let students: Array<{id: number; grade: Number;}> = [];

    for (let student of this.dataSource.data) {
      if (student.student_grade != null) {
        students.push({
          id: student.student_id,
          grade: student.student_grade
        });
      }
    }

    const payload = {students}

    this.store.dispatch(setLoadingSpinner({status: true}));

    if (students.length > 0) {
      this.store.dispatch(encodeWorkItemStudentsGrade({payload, subjectGradeId: this.data.work_item_id}));
    } 
  }

  close(): void {
    this.onClose.next({ action: 'cancel' });
    this.bsModalRef.hide();
  }
}